var _effectorFileName = "/src/page-content/payment/components/payment-form/model.ts";
import { createEffect, createEvent, createStore, sample } from 'effector';
import { $servicesList, postPaymentDataMutation, postPromocodeDataMutation } from '@/shared/api/payment/api';
import { PromocodeData } from '@/shared/api/payment/types';
import { PaymentData } from './types';
export const paymentDataSent = createEvent<PaymentData>({
  loc: {
    file: _effectorFileName,
    line: 8,
    column: 31
  },
  name: "paymentDataSent",
  sid: "5ismns"
});
const redirectUserOnSuccessPaymentSendFx = createEffect<(link: string) => void>(link => window.location.replace(link), {
  loc: {
    file: _effectorFileName,
    line: 10,
    column: 43
  },
  name: "redirectUserOnSuccessPaymentSendFx",
  sid: "qxtfgh"
});
sample({
  and: [{
    clock: paymentDataSent,
    target: postPaymentDataMutation.start
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 14,
      column: 0
    },
    sid: "wtfwmp"
  }
});
sample({
  and: [{
    clock: postPaymentDataMutation.finished.success,
    fn: data => data.result.link,
    target: redirectUserOnSuccessPaymentSendFx
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 19,
      column: 0
    },
    sid: "ww6vli"
  }
});
export const $isPromocodeAccepted = createStore<boolean | null>(null, {
  loc: {
    file: _effectorFileName,
    line: 25,
    column: 36
  },
  name: "$isPromocodeAccepted",
  sid: "-wu89o5"
});
export const promocodeDataSent = createEvent<PromocodeData>({
  loc: {
    file: _effectorFileName,
    line: 27,
    column: 33
  },
  name: "promocodeDataSent",
  sid: "8x4yj9"
});
sample({
  and: [{
    clock: promocodeDataSent,
    target: postPromocodeDataMutation.start
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 29,
      column: 0
    },
    sid: "xd8hzp"
  }
});
sample({
  and: [{
    clock: postPromocodeDataMutation.finished.success,
    fn: () => true,
    target: $isPromocodeAccepted
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 34,
      column: 0
    },
    sid: "xrj5f3"
  }
});
sample({
  and: [{
    clock: postPromocodeDataMutation.finished.success,
    fn: data => data.result.services ?? [],
    target: $servicesList
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 40,
      column: 0
    },
    sid: "y6dlfu"
  }
});
sample({
  and: [{
    clock: postPromocodeDataMutation.finished.failure,
    fn: () => false,
    target: $isPromocodeAccepted
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 46,
      column: 0
    },
    sid: "y9od00"
  }
});